export const SESSION_EXPIRED_MESSAGE = 'Session expired';

/** Map legacy auth API errors to a single user-facing session message. */
export function normalizeAuthSessionMessage(message) {
  if (typeof message !== 'string') return message;
  const m = message.trim().toLowerCase();
  if (
    m === 'invalid token' ||
    m === 'token expired' ||
    m === 'no token provided'
  ) {
    return SESSION_EXPIRED_MESSAGE;
  }
  return message;
}

/**
 * White-label API error messages for display in the UI.
 * Replaces provider-specific terms so users never see them.
 */
export function sanitizeForDisplay(message) {
  if (typeof message !== 'string') return message;
  return normalizeAuthSessionMessage(message)
    .replace(/\bShopify\s+order\s+ID\b/gi, 'Store order ID')
    .replace(/\bShopify\s+order\b/gi, 'Order')
    .replace(/\bShopify\s+API\b/gi, 'Store API')
    .replace(/\bShopify\s+connection\b/gi, 'Store connection')
    .replace(/\bShopify\s+admin\b/gi, 'store admin')
    .replace(/\bShopify\s+webhook\b/gi, 'Event')
    .replace(/\bfrom\s+Shopify\b/gi, 'from store')
    .replace(/\bin\s+Shopify\b/gi, 'in store')
    .replace(/\bto\s+Shopify\b/gi, 'to store')
    .replace(/\bShopify\s+ID\b/gi, 'Store ID')
    .replace(/\bShopify\b/g, 'Store');
}
